import { useLocation } from "react-router-dom";

import facesDef from "assets/images/dashboard/faces.png";
import bots from "assets/images/dashboard/bots.png";

import { COUNT_PERFORMERS_BOTS, getPeopleCount, getPeopleWord, isListenersPage } from "utils/helpers";

import "./IntroPerformers.scss";

export default function IntroPerformers({ marketMode = null, shouldShowBreadcrumbs }) {
  const { pathname } = useLocation();
  const marketModeBots = marketMode && marketMode.bots;

  return (
    <div className={`intro-performers ${shouldShowBreadcrumbs ? "other-style" : ""}`}>
        {marketModeBots
          ? <img src={bots} alt="Исполнители-боты" className="intro-performers__bots-img" />
          : <img src={facesDef} alt="Исполнители-люди" className="intro-performers__people-img" />
        }

        {marketModeBots
          ? <div className="intro-performers__bots-description">
              <p className="intro-performers__bots-description-title">{COUNT_PERFORMERS_BOTS.toLocaleString()} <span>ботов</span></p>
              <p className="intro-performers__bots-description-text">в вашем распоряжении</p>
            </div>
          : <div className="intro-performers__people-description">
              <p className="intro-performers__people-description-title">+ {getPeopleCount(pathname).toLocaleString()}{" "} <span>{`${getPeopleWord(pathname, 'prepositional')}й`}</span></p>
              {/* Раньше здесь было «и ни одного бота» — это противоречило тарифу
                  «Боты», который продается на этой же странице. Для музыкальных
                  страниц уточняем сегмент базы: их 81 000 против 124 000 на
                  остальных, и без пояснения числа выглядят разнобоем. */}
              <p className="intro-performers__people-description-text">
                {isListenersPage(pathname) ? "в музыкальном сегменте базы" : "живые люди, а не аккаунты"}
              </p>
            </div>
        }        
    </div>
  );
}
